'use client';

import React from 'react';
import { QueryProvider } from '@/providers/query-provider';

export function AppProviders({ children }: { children: React.ReactNode }) {
  return <QueryProvider>{children}</QueryProvider>;
}
